<template>
  <svg version="1.1" v-html="xmlnsPath" :class="clazz" :viewBox="box"  :style="style"></svg>
</template>

<script>
  import * as svgicon from 'vue-svgicon';
  export default {
    extends: svgicon,
    computed: {
      xmlnsPath() {
        if (this.iconData) {
          return `<g xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">${this.iconData.data}</g>`
        }
      }
    }
  }
</script>
